import { render } from "./PositionsView.vue?vue&type=template&id=666a5f6e&scoped=true"
import script from "./PositionsView.vue?vue&type=script&lang=js"
export * from "./PositionsView.vue?vue&type=script&lang=js"

import "./PositionsView.vue?vue&type=style&index=0&id=666a5f6e&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-666a5f6e"]])

export default __exports__